export default __webpack_public_path__ + "a5d121f11b1c8acbb5913431a8342209.svg";